import React from 'react';
import { Customer } from '../types';

interface CustomersTabProps {
  customers: Customer[];
  onViewDetails: (customer: Customer) => void;
  onViewAsCustomer: (customerId: string) => void;
}

export const CustomersTab: React.FC<CustomersTabProps> = ({
  customers,
  onViewDetails,
  onViewAsCustomer
}) => {
  return (
    <div style={{
      background: 'white',
      borderRadius: '0 0 15px 15px',
      padding: '2rem',
      boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
      minHeight: '500px'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '2rem'
      }}>
        <h2 style={{ color: '#228B22', margin: 0 }}>Customer Management</h2>
        <span style={{ color: '#666', fontSize: '0.9rem' }}>
          {customers.length} customers
        </span>
      </div>

      {customers.length === 0 ? (
        <div style={{
          textAlign: 'center',
          padding: '3rem',
          color: '#666'
        }}>
          <p>No customers found.</p>
        </div>
      ) : (
        <div style={{ display: 'grid', gap: '1rem' }}>
          {customers.map(customer => (
            <div
              key={customer._id}
              style={{
                background: '#f8f9fa',
                border: '1px solid #e9ecef',
                borderRadius: '12px',
                padding: '1.5rem',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              <div style={{ flex: 1 }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '1rem',
                  marginBottom: '0.5rem'
                }}>
                  <div>
                    <h4 style={{
                      margin: 0,
                      color: '#228B22',
                      fontSize: '1.2rem'
                    }}>
                      {customer.email}
                    </h4>
                    <div style={{
                      fontSize: '0.85rem',
                      color: '#666',
                      marginTop: '0.25rem'
                    }}>
                      {customer.name}
                    </div>
                  </div>
                  {customer.stats.totalOrders > 5 && (
                    <span style={{
                      background: '#ffeaa7',
                      color: '#d63031',
                      padding: '0.25rem 0.75rem',
                      borderRadius: '20px',
                      fontSize: '0.8rem',
                      fontWeight: '600'
                    }}>
                      VIP
                    </span>
                  )}
                </div>

                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                  gap: '1rem',
                  color: '#666',
                  fontSize: '0.9rem'
                }}>
                  <div>🛒 {customer.stats.totalOrders} orders</div>
                  <div>🌳 {customer.stats.totalTreesOrdered} trees ordered</div>
                  <div>💰 ${(customer.stats.totalAmountSpent / 100).toFixed(2)} spent</div>
                  {customer.stats.lastOrderDate && (
                    <div>📅 Last order: {new Date(customer.stats.lastOrderDate).toLocaleDateString()}</div>
                  )}
                </div>

                {/* Recent orders preview */}
                {customer.recentOrders && customer.recentOrders.length > 0 && (
                  <div style={{ marginTop: '0.75rem', fontSize: '0.85rem', color: '#888' }}>
                    Recent: {customer.recentOrders.slice(0, 3).map((order, idx) => (
                      <span key={order._id}>
                        {idx > 0 && ', '}
                        {order.status === 'completed' && '✅'}
                        {order.status === 'planted' && '🌱'}
                        {order.status === 'assigned' && '👷'}
                        {order.status === 'pending' && '⏳'}
                        {' '}{order.trees || order.treesOrdered} trees
                      </span>
                    ))}
                    {customer.recentOrders.length > 3 && ` + ${customer.recentOrders.length - 3} more`}
                  </div>
                )}
              </div>

              <div style={{ display: 'flex', gap: '0.5rem', flexDirection: 'column' }}>
                <button
                  onClick={() => onViewDetails(customer)}
                  style={{
                    padding: '0.5rem 1rem',
                    background: '#0d6efd',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontSize: '0.9rem',
                    whiteSpace: 'nowrap'
                  }}
                >
                  View Details
                </button>
                <button
                  onClick={() => onViewAsCustomer(customer._id)}
                  style={{
                    padding: '0.5rem 1rem',
                    background: '#228B22',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontSize: '0.9rem',
                    whiteSpace: 'nowrap'
                  }}
                >
                  👤 View as Customer
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
